import "./MobileMenu.scss";
import { NavLink } from "react-router-dom";
import { useEffect, useCallback } from "react";

function MobileMenu({ isOpen, onClose, CLOUDFRONT_URL }) {
  // Function to check screen size and close menu if needed
  const checkScreenSize = useCallback(() => {
    if (isOpen && window.innerWidth >= 768) {
      // 768px is your tablet breakpoint
      onClose();
    }
  }, [isOpen, onClose]);

  // Prevent scrolling on body when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";

      // Add resize event listener when menu opens
      window.addEventListener("resize", checkScreenSize);
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("resize", checkScreenSize);
    };
  }, [isOpen, checkScreenSize]);

  if (!isOpen) return null;

  return (
    <div className="mobile-menu">
      <div className="mobile-menu__overlay" onClick={onClose} />
      <div className="mobile-menu__content">
        <div className="mobile-menu__close" onClick={onClose}>
          &times;
        </div>
        <nav className="mobile-menu__nav">
          <ul className="mobile-menu__list">
            <li className="mobile-menu__list-item">
              <NavLink className="mobile-menu__link" to="/" onClick={onClose}>
                home
              </NavLink>
            </li>
            {/* <li className="mobile-menu__list-item">
              <NavLink
                className="mobile-menu__link"
                to="/blog"
                onClick={onClose}
              >
                blog
              </NavLink>
            </li> */}
            <li className="mobile-menu__list-item">
              <NavLink
                className="mobile-menu__link"
                to="/research"
                onClick={onClose}
              >
                research
              </NavLink>
            </li>
            {/* <li className="mobile-menu__list-item">
              <NavLink
                className="mobile-menu__link"
                to="/contact"
                onClick={onClose}
              >
                contact
              </NavLink>
            </li> */}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default MobileMenu;
